import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './DialogTestPoll.module.css';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Components
import AnswerPollForm from '../AnswerPollForm/AnswerPollForm';

// Interfaces
import { AssignedInquiry, PatientInquiryAnswer, Poll, PollQuestion } from '../../../interfaces/Poll';
import { OptionAutocomplete } from '../../../interfaces/Input';
import { Case, Patient } from '../../../interfaces/Patient';
import Select from '../../UI/Select/Select';
interface Props {
    patientID: Patient['id']
    caseID: Case['id']
    addPatientInquiry: (inquiry: AssignedInquiry) => void
    closeDialog: () => void
}

const DialogTestPoll: React.FC<Props> = ({ patientID, caseID, addPatientInquiry, closeDialog }) => {

    const { t } = useTranslation();

    const { sendRequest } = useHttp<Poll[]>();
    const [professionalPolls, setProfessionalPolls] = useState<Poll[]>([]);

    const [selectedPollID, setSelectedPollID] = useState<Poll['id'] | null>(null);

    const [showAnswerPollDialog, setShowAnswerPollDialog] = useState(false);

    useEffect(() => {
        sendRequest({
            url: getEnvironmentApiUrl() + 'inquiry/all',
            method: 'POST',
            body: {
                filter: { is_profesional_inquiry: true, enabled: true, modified: false, deleted: false },
                params: {}
            }
        }, (data) => {
            setProfessionalPolls(data);
        });
    }, [sendRequest]);

    const optionsSelect = professionalPolls.map(p => ({
        id: p.id ?? -1,
        label: p.name ?? ''
    }));

    const handleChangePoll = (o: OptionAutocomplete) => {
        setSelectedPollID(Number(o.id));
    };

    const selectedPoll = professionalPolls.find(p => p.id === selectedPollID);

    const { sendRequest: assignInquiry } = useHttp<AssignedInquiry>();
    const { sendRequest: postAnswers } = useHttp();


    const handleClickSend = (questions: PollQuestion[]) => {

        const returnedAnswers: PatientInquiryAnswer[] = [];

        const filledDate = new Date().toISOString();
        questions.forEach(question => {
            const answer = question.answers.find(answer => answer?.inquiry_question_id === question.id);
            const answerID = question.inquiry_question_type_id === 1 ? answer?.id : questions?.find(q => q.id === question.id)?.answers?.[0]?.id;
            returnedAnswers.push({
                answer: {
                    description: answer?.description,
                    emoji: '',
                    id: answerID,
                    inquiry_question_id: answer?.inquiry_question_id,
                    order: answer?.order,
                    value: answer?.value,
                },
                carer_id: null,
                date: filledDate,
                free_description: answer?.description,
                inquiry_answer_id: answerID,
                patient_id: patientID,
            });
        });

        assignAndsendAnswers(returnedAnswers, filledDate);
    }

    const assignAndsendAnswers = (answers: PatientInquiryAnswer[], date: string) => {
        if (selectedPollID === null || selectedPollID === undefined) return;
        assignInquiry({
            url: getEnvironmentApiUrl() + 'patient_inquiries',
            method: 'POST',
            body: {
                case_id: caseID,
                patient_id: patientID,
                inquiry_id: selectedPollID,
                assigned_date: date,
                filled_date: null,
            }
        }, (data) => {
            postAnswers({
                url: getEnvironmentApiUrl() + 'inquiry/fill',
                method: 'POST',
                body: answers.map(a => ({
                    ...a,
                    patient_inquiries_id: data.id
                })),
            }, () => {
                if (selectedPoll) addPatientInquiry({
                    ...data,
                    inquiry: selectedPoll,
                    filled_date: date
                });
                closeDialog();
            });
        });
    };



    return (
        <div className='dialog'>
            {!showAnswerPollDialog ?
                <>
                    <h1 className='dialogTitle'>{t('select_test')}</h1>
                    <div className={styles.containerSelect}>
                        <Select
                            options={optionsSelect}
                            value={selectedPoll?.name ?? ''}
                            onSelect={handleChangePoll}
                        />
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <button className='button btnPrimary' disabled={selectedPollID === null} onClick={() => setShowAnswerPollDialog(true)}>
                            {t('continue')}
                        </button>
                    </div>
                </>
                :
                <>
                    <h1 className='dialogTitle'>{selectedPoll?.name ?? ''}</h1>
                    <AnswerPollForm
                        poll={selectedPoll}
                        handleClickSend={handleClickSend}
                        closeDialog={closeDialog}
                    />
                </>
            }
        </div>
    );
};

export default DialogTestPoll;